<div class="w-full flex flex-col md:flex-row items-center justify-between pb-2 sm:pb-2">
    <label class="text-base font-medium ml-4 p-3 sm:font-semibold">Carpet Area</label>
    <div class="flex space-x-3 mt-2 md:mt-0">
        <button class="ml-4" mat-flat-button [color]="'primary'" (click)="new('Carpet Area')"
            *ngIf="(carpetAreaMeasurements$ | async)?.length === 0">
            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
            <span class="ml-2 mr-1">Add</span>
        </button>
        <button class="ml-4" mat-flat-button [color]="'primary'" (click)="deleteSelectedRows()"
            *ngIf="selection.selected.length > 0">
            <mat-icon [svgIcon]="'delete_forever'"></mat-icon>
            <span class="ml-2 mr-1">All Delete</span>
        </button>
    </div>
    <fuse-alert [appearance]="'soft'" *ngIf="alert" [dismissible]="true" [dismissed]="false" [type]="alert.type">
        {{alert.message}}
    </fuse-alert>
</div>
<div class="relative overflow-x-auto overflow-y-auto ">
    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 table-fixed">
        <thead class="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th scope="col" class="w-5 p-1 text-center pr-6"></th>
                <th scope="col" class="w-5 text-center p-2">
                    <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelectedCheckBox"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" [color]="'primary'"
                        [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <th scope="col" class="w-16 px-0 py-1 text-center">Order</th>
                <th scope="col" class="w-24 p-0 pr-2">Type</th>
                <th scope="col" class="w-250px p-0 pr-6">Particular</th>
                <th scope="col" class="w-28 p-0 text-center">Width (In.Ft)</th>
                <th scope="col" class="w-28 p-0 text-center">Depth (In.Ft)</th>
                <th scope="col" class="w-28 px-0 py-2 text-center">Total (In.Sq.Ft)</th>
                <th scope="col" class="w-32 px-0 py-2 text-center">
                    <span class="sr-only">Actions</span>
                </th>
            </tr>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
            <ng-container *ngIf="carpetAreaMeasurements$ | async as siteMeasurements">
                <ng-container *ngIf="siteMeasurements.length; else noSiteMeasurement">
                    <tr *ngFor="let siteMeasurement of siteMeasurements; let i = index; let lastIndex = last; trackBy: trackByFn"
                        class="border-b dark:border-gray-700 hover:bg-blue-50 dark:hover:bg-gray-900 transition">
                        <td class="text-center align-middle border border-gray-200 dark:border-gray-700 bg-gray-50">
                            <mat-icon class="flex items-center cursor-move text-gray-400"
                                cdkDrag>drag_indicator</mat-icon>
                        </td>
                        <td class="w-5 text-center align-middle p-2 border border-gray-200 dark:border-gray-700">
                            <mat-checkbox [(checked)]="siteMeasurement.selected" color="primary"
                                (change)="updateCheckedList($event,siteMeasurement)"></mat-checkbox>
                        </td>
                        <td class="text-center align-middle border border-gray-200 dark:border-gray-700">
                            <input matInput type="number"
                                class="w-12 bg-transparent px-1 py-0.5 text-sm h-7 text-center border-0 focus:ring-0 focus:outline-none transition"
                                style="font-size: 12px;" [(ngModel)]="siteMeasurement.orderIndex" readonly />
                        </td>
                        <td class="align-middle border border-gray-200 dark:border-gray-700">
                            <input matInput type="text"
                                class="w-24 bg-transparent px-1 py-0.5 text-sm h-7 border-0 focus:ring-0 focus:outline-none transition"
                                style="font-size: 12px;" [(ngModel)]="siteMeasurement.type" readonly />
                        </td>
                        <td class="align-middle border border-gray-200 dark:border-gray-700">
                            <input matInput type="text"
                                class="w-full bg-transparent px-1 py-0.5 text-sm h-7 border-0 focus:ring-0 focus:outline-none focus:bg-yellow-100 transition"
                                style="font-size: 12px;" [(ngModel)]="siteMeasurement.particular"
                                [matAutocomplete]="autoParticular"
                                (ngModelChange)="filterParticularOptions(siteMeasurement, i)"
                                (blur)="onFieldChange(siteMeasurement, 'particular')"
                                [attr.title]="siteMeasurement.particular" required />
                            <mat-autocomplete #autoParticular="matAutocomplete" [displayWith]="displayOptionsFn"
                                (optionSelected)="onAutocompleteSelected(siteMeasurement, $event.option.value)">
                                <mat-option *ngFor="let option of filteredOptions[i] || []" [value]="option.name">
                                    {{ option.name }}
                                </mat-option>
                            </mat-autocomplete>


                        <td class="text-center align-middle border border-gray-200 dark:border-gray-700">
                            <input matInput type="number"
                                class="w-20 bg-transparent px-1 py-0.5 text-sm h-7 text-right border-0 focus:ring-0 focus:outline-none focus:bg-yellow-100 transition"
                                style="font-size: 12px;" [(ngModel)]="siteMeasurement.width"
                                (focus)="onInputInit(siteMeasurement, 'width')"
                                (blur)="calculateTotal(siteMeasurement); onFieldChange(siteMeasurement, 'width')" />
                        </td>
                        <td class="text-center align-middle border border-gray-200 dark:border-gray-700">
                            <input matInput type="number"
                                class="w-20 bg-transparent px-1 py-0.5 text-sm h-7 text-right border-0 focus:ring-0 focus:outline-none focus:bg-yellow-100 transition"
                                style="font-size: 12px;" [(ngModel)]="siteMeasurement.depth"
                                (focus)="onInputInit(siteMeasurement, 'depth')"
                                (blur)="calculateTotal(siteMeasurement); onFieldChange(siteMeasurement, 'depth')" />
                        </td>
                        <td class="text-center align-middle border border-gray-200 dark:border-gray-700">
                            <input matInput type="number"
                                class="w-20 bg-transparent px-1 py-0.5 text-sm h-7 text-right border-0 focus:ring-0 focus:outline-none focus:bg-yellow-100 transition"
                                style="font-size: 12px;" [(ngModel)]="siteMeasurement.total"
                                (blur)="onFieldChange(siteMeasurement, 'total')"
                                [readonly]="siteMeasurement.width != 0 || siteMeasurement.depth != 0" />
                        </td>
                        <td
                            class="flex items-center justify-end gap-1 align-middle border border-gray-200 dark:border-gray-700">
                            <button class="ml-2" mat-icon-button *ngIf="lastIndex && !siteMeasurement.isEditing"
                                (click)="new('Carpet Area')">
                                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                            </button>
                            <button class="ml-2" mat-icon-button *ngIf="siteMeasurement.isEditing">
                                <mat-icon svgIcon="close" (click)="cancelNewRow(i)"></mat-icon>
                            </button>
                            <button mat-icon-button *ngIf="siteMeasurement.id !== 0"
                                (click)="delete(siteMeasurement.id)">
                                <mat-icon svgIcon="delete_forever"></mat-icon>
                            </button>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
            <ng-template #noSiteMeasurement>
                <tr>
                    <td colspan="9" class="text-center py-4 text-gray-400 font-semibold">
                        There are no Site Measurements!
                    </td>
                </tr>
            </ng-template>
        </tbody>
        <tfoot *ngIf="(carpetAreaMeasurements$ | async)?.length !== 0">
            <tr class="font-semibold text-gray-900 dark:text-white bg-gray-50 dark:bg-gray-900">
                <td colspan="4" class="px-2 py-3 border border-gray-200 dark:border-gray-700">Total (Sq.Ft)</td>
                <td class="px-2 py-3 border border-gray-200 dark:border-gray-700"></td>
                <td class="px-2 py-3 border border-gray-200 dark:border-gray-700"></td>
                <td class="text-right">
                    <label class="text-sm text-gray-500 block">SBU (In Sq.Ft)</label>
                    <input matInput [(ngModel)]="report.siteSuperBuiltUp" [readonly]="reportType === 'LandAndBuilding'"
                        class=" align-middle border border-gray-200 dark:border-gray-700">
                </td>
                <td class="text-right">
                    <label class="text-sm text-gray-500 block">Area (In Sq.Ft)</label>
                    <input matInput [value]="report.siteArea | number:'1.2-2':'en-IN'"
                        class=" align-middle border border-gray-200 dark:border-gray-700" readonly>
                </td>

                <td class="px-2 py-3 border border-gray-200 dark:border-gray-700"></td>
            </tr>
        </tfoot>
    </table>
</div>